import { useAuth } from "@clerk/clerk-react";
import { Separator } from "@radix-ui/react-separator";
import PopUp from "Components/PopUp/PopUp";
import { Popover, PopoverContent, PopoverTrigger } from "Components/ui/popover";
import { Bell, BellDot } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getSampleNotification,
  markAllAsRead,
} from "../../Redux/Notifications/NotificationsAction";
import { Skeleton } from "Components/ui/skeleton";
import { formatDistanceToNow } from "date-fns";

function NotificationPop() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { getToken } = useAuth();

  useEffect(() => {
    if (open) {
      dispatch(getSampleNotification(getToken));
    }
  }, [open]);

  const {
    markAllAsReadLoading,
    getSampleNotificationLoading,
    sampleNotification,
  } = useSelector((state) => state.NotificationsReducer);

  return (
    <Popover open={open} onOpenChange={setOpen} className="w-full">
      <PopoverTrigger asChild>
        <div className="cursor-pointer flex flex-rwo gap-4 items-center">
          <BellDot color="var(--baseColor)" />
        </div>
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        className="mt-[1rem] w-[100vw] sm:max-w-[40vw] overflow-x-hidden"
      >
        <div className="flex items-center justify-between">
          <div className="font-N_Medium text-2xl">Notifications</div>
          <div
            className="text-sm text-white-opacity cursor-pointer hover:underline"
            onClick={() =>
              !markAllAsReadLoading && dispatch(markAllAsRead(getToken, true))
            }
          >
            Mark all as read
          </div>
        </div>
        <Separator className="bg-border-darkNew h-[0.2rem] rounded-xl mt-4 w-[120%]  ml-[-10%]" />
        {getSampleNotificationLoading || markAllAsReadLoading ? (
          Array.from({ length: 5 }).map((_, i) => (
            <>
              <div key={i} className="flex items-center justify-between py-4">
                <div className="space-y-2">
                  <Skeleton className="h-5 w-32 " />
                  <Skeleton className="h-4 w-40 " />
                </div>
                <Skeleton className="h-4 w-16 " />
              </div>
              {i <= 3 && <Skeleton className="h-[0.15rem] w-full " />}
            </>
          ))
        ) : (
          <div className="flex-col gap-4 flex mt-4 max-h-[40vh]  overflow-y-auto hideScrollBar">
            {sampleNotification?.length > 0
              ? sampleNotification?.map((item, index) => (
                  <div className="flex-col gap-4 flex " key={index}>
                    <div className="flex justify-between items-center ">
                      <div className="w-[70%]">
                        <div className="text-base font-N_Medium">
                          {item.title}
                        </div>
                        <div className="text-sm text-white-opacity font-N_Roman">
                          {item.description}
                        </div>
                      </div>
                      <div>
                        <div className="flex flex-col items-end gap-2">
                          {!item?.sendTo[0]?.isRead && (
                            <div className="w-2 h-2 rounded-full bg-red"></div>
                          )}
                          <div className="text-xs text-white-opacity font-N_Roman">
                            {formatDistanceToNow(new Date(item.createdAt), {
                              addSuffix: true,
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    {index != sampleNotification?.length - 1 && (
                      <Separator className="bg-borderChallenge w-full opacity-20 h-[0.1rem] rounded-xl" />
                    )}
                  </div>
                ))
              : !getSampleNotificationLoading && (
                  <div className="text-base text-white-opacity  cursor-default">
                    No New Notifications!
                  </div>
                )}
          </div>
        )}
        <Separator className="bg-border-darkNew  h-[0.2rem] rounded-xl mt-4 w-[120%]  ml-[-10%]" />
        <div
          className="text-base text-primary text-center font-N_Medium mt-4 cursor-pointer hover:underline"
          onClick={() => {
            //close popover
            setOpen(false);
            navigate("/notifications");
          }}
        >
          View All Notifications
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default NotificationPop;
